import { Badge, styled } from "@mui/material";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Icon } from "../../../common/components";
import { useSelector } from "../../../common/hooks/useSelector";
import { palette } from "../../../styles/theme";
import { ROUTES } from "../../../constant/common.constant";
import { useThemeBreakpoints } from "../../../utils/themeUtils";
import { getReducedCartItems } from "../../../utils/CartUtils";

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    right: "6px",
    top: "4px",
    height: 10,
    paddingRight: "3px",
    paddingLeft: "3px",
    minWidth: "fit-content",
    maxWidth: "fit-content",
  },
}));

interface Props {
  iconSize?: number;
  noPadding?: boolean;
  onClick?: () => void;
}

const Cart = ({ iconSize = 24, noPadding, onClick }: Props) => {
  const navigate = useNavigate();
  const { isMobile } = useThemeBreakpoints();
  const { cart } = useSelector((state) => state.cart);

  const getCartItemCount = () => {
    const count = getReducedCartItems(cart?.comboItems ?? [])?.length;
    if (count) {
      if (count > 100) {
        return "99+";
      } else {
        return count;
      }
    }
    return undefined;
  };

  return (
    <Box
      {...(noPadding || isMobile ? {} : { px: 1 })}
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={onClick ?? (() => navigate(ROUTES.CART))}
      data-test="cart.link"
    >
      <StyledBadge
        badgeContent={getCartItemCount()}
        color="error"
        data-test="cart.badge"
      >
        <Icon
          icon="shopping_cart"
          color={palette.grey.nearBlack}
          size={iconSize}
        />
      </StyledBadge>
    </Box>
  );
};

export default memo(Cart);
